import { giphyAqua, giphyBlue, giphyGreen, giphyIndigo, giphyPink, giphyRed, giphyYellow } from '@giphy/js-brand'
import { getCssBackgroundFromColorString } from '../utils/color-utils'
import CreationToolGradient from './gradient'

/**
 * Color picker color values.
 */
enum CreationToolColorPickerColor {
    Blue = 'CT_COLOR_BLUE',
    Indigo = 'CT_COLOR_INDIGO',
    Red = 'CT_COLOR_RED',
    Green = 'CT_COLOR_GREEN',
    Yellow = 'CT_COLOR_YELLOW',
    Pink = 'CT_COLOR_PINK',
    White = 'CT_COLOR_WHITE',
    Black = 'CT_COLOR_BLACK',
    Aqua = 'CT_COLOR_AQUA',
    RedYellow = 'CT_COLOR_RED_YELLOW',
    PinkIndigo = 'CT_COLOR_PINK_INDIGO',
    IndigoBlue = 'CT_COLOR_INDIGO_BLUE',
}

namespace CreationToolColorPickerColor {
    /**
     * Returns all of the colors in order.
     */
    export function all(): CreationToolColorPickerColor[] {
        return [
            CreationToolColorPickerColor.White,
            CreationToolColorPickerColor.Black,
            CreationToolColorPickerColor.Blue,
            CreationToolColorPickerColor.Indigo,
            CreationToolColorPickerColor.Red,
            CreationToolColorPickerColor.Green,
            CreationToolColorPickerColor.Yellow,
            CreationToolColorPickerColor.Aqua,
            CreationToolColorPickerColor.Pink,
            CreationToolColorPickerColor.RedYellow,
            CreationToolColorPickerColor.PinkIndigo,
            CreationToolColorPickerColor.IndigoBlue,
        ]
    }

    /**
     * Returns the color picker color's hex value.
     */
    export function color(color: CreationToolColorPickerColor): string {
        switch (color) {
            case CreationToolColorPickerColor.Blue:
                return giphyBlue
            case CreationToolColorPickerColor.Indigo:
                return giphyIndigo
            case CreationToolColorPickerColor.Red:
                return giphyRed
            case CreationToolColorPickerColor.Green:
                return giphyGreen
            case CreationToolColorPickerColor.Yellow:
                return giphyYellow
            case CreationToolColorPickerColor.Pink:
                return giphyPink
            case CreationToolColorPickerColor.White:
                return '#fff'
            case CreationToolColorPickerColor.Black:
                return '#000'
            case CreationToolColorPickerColor.Aqua:
                return giphyAqua
            case CreationToolColorPickerColor.RedYellow:
                return CreationToolGradient.colors(CreationToolGradient.RedYellow).join(',')
            case CreationToolColorPickerColor.PinkIndigo:
                return CreationToolGradient.colors(CreationToolGradient.PinkIndigo).join(',')
            case CreationToolColorPickerColor.IndigoBlue:
                return CreationToolGradient.colors(CreationToolGradient.IndigoBlue).join(',')
        }
    }

    /**
     * Returns the color picker color's border color.
     */
    export function borderColor(color: CreationToolColorPickerColor): string {
        switch (color) {
            case CreationToolColorPickerColor.Black:
                return '#979797'
            default:
                return ''
        }
    }

    /**
     * Returns the color's css for use with background colors on the color previews.
     */
    export function css(color: CreationToolColorPickerColor): string {
        const colorValue = CreationToolColorPickerColor.color(color)
        return getCssBackgroundFromColorString(colorValue)
    }
}

export default CreationToolColorPickerColor
